import FileStats from "../../shared/transaction/all-transaction/transaction-stat";
import WithdrawalTableHolder from "../../shared/transaction/all-transaction/transaction-history-table/withdrawal-table-holder";
import PaymentTableHolder from "../../shared/transaction/all-transaction/transaction-history-table/payment-table-holder";
import { useWithdrawals } from "../../../hooks/use-withdrawal";
import { usePayments } from "../../../hooks/use-payments";

export default function Transactions() {
  const { data: withdrawals = [], isLoading, error } = useWithdrawals();
  const { data: payments = [], isLoading: isL, error: er } = usePayments();
  return (
    <div className="grid grid-cols-6 gap-6 @container 3xl:gap-8">
      <FileStats
        className="col-span-full"
        payments={payments}
        withdrawals={withdrawals}
      />
      <PaymentTableHolder
        payments={payments}
        isLoading={isLoading}
        error={error}
      />
      <WithdrawalTableHolder
        withdrawals={withdrawals}
        isLoading={isL}
        error={er}
      />
    </div>
  );
}
